/* global __DEVELOPMENT__ */

import React from 'react'
import { hydrate } from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import FastClick from 'fastclick'

import rootReducer from '../shared/reducers/'
import { gaMiddleware } from '../shared/middlewares/'
import { initializeGa } from '../shared/utils/analytics'
import { MOUNTING_NODES, getInitialState } from './globals'

import App from '../shared/components/App'

const enchancer = __DEVELOPMENT__
  ? require('redux-devtools-extension').composeWithDevTools
  : compose

const middlewares = applyMiddleware(thunk, gaMiddleware)
const isMounted = node => !node.getAttribute('data-already-mounted')

let ga = false

MOUNTING_NODES.filter(isMounted).forEach(node => {
  if (!ga) {
    initializeGa(node.getAttribute('data-tracking-enabled') === 'true')
    ga = true
  }
  const store = createStore(rootReducer, getInitialState(node), enchancer(middlewares))
  hydrate(
    <Provider store={store}>
      <App />
    </Provider>,
    node
  )
  node.setAttribute('data-already-mounted', 'mounted')
  FastClick.attach(node)

  return node
})



// WEBPACK FOOTER //
// ./src/client/index.js